import { Injectable } from '@angular/core';
import { CouponModel, ProductModel, SortModel } from '../models/data.model';
import { CommonService as AbsCommonService } from 'abs-ngx-library/src/lib/core'
@Injectable({
  providedIn: 'root'
})
export class SortService {
  private windowObj: any = window;
  private sorts: SortModel[] = new Array<SortModel>();
  private available: string[];
  private default!: SortModel;
  public rules: any;

  private initRules() {
    let results: { [type: string]: SortModel };
    results = {
      'a-z': {
        field: 'name',
        rule: [{ field: 'name', direction: -1, type: 'string' }],
        label: 'Alphabetical A - Z',
        sort_at: 'client'
      },
      'a-z-description': {
        field: 'description',
        rule: [{ field: 'description', direction: -1, type: 'string' }],
        label: 'Alphabetically',
        sort_at: 'client'
      },
      'z-a': {
        field: 'name',
        rule: [{ field: 'name', direction: -1, type: 'string' }],
        label: 'Alphabetical Z - A',
        sort_at: 'client'
      },
      'search-rank': {
        field: 'searchRank',
        rule: [
          { field: 'searchRank', direction: -1, type: 'number' },
          { field: 'name', direction: -1, type: 'string' }
        ],
        label: 'Search Ranking',
        sort_at: 'client'
      },
      'most-popular': {
        field: 'salesRank',
        rule: [
          { field: 'salesRank', direction: 1, type: 'number' },
          { field: 'name', direction: -1, type: 'string' }
        ],
        label: 'Most Popular',
        sort_at: 'client'
      },
      'price-low-high': {
        field: 'price',
        rule: [
          { field: 'price', direction: 1, type: 'number' },
          { field: 'name', direction: -1, type: 'string' }
        ],
        label: 'Price - Low to High',
        sort_at: 'client'
      },
      'purchase-history': {
        field: 'purchaseRank',
        rule: [
          { field: 'purchaseRank', direction: -1, type: 'string' }
        ],
        label: 'Purchase History',
        sort_at: 'client'
      },
      'new-offers': {
        field: 'arrivalRank',
        rule: [
          { field: 'arrivalRank', direction: 1, type: 'string' }
        ],
        label: 'New Offers',
        sort_at: 'client'
      },
      'about-to-expire': {
        field: 'expiryRank',
        rule: [
          { field: 'expiryRank', direction: 1, type: 'string' }
        ],
        label: 'About to Expire',
        sort_at: 'client'
      },
      'category': {
        field: 'categoryId',
        rule: [
          { field: 'categoryId', direction: 1, type: 'string' }
        ],
        label: 'Category',
        sort_at: 'client'
      },
      'expiry-date': {
        field: 'endDate',
        rule: [
          { field: 'endDate', direction: 1, type: 'string' }
        ],
        label: 'Expiry Date',
        sort_at: 'client'
      },
      'added-date': {
        field: 'addedDate',
        rule: [
          { field: 'addedDate', direction: 1, type: 'string' }
        ],
        label: 'Added Date',
        sort_at: 'client'
      },
      'reward-card-specials': {
        field: 'promoDescription',
        rule: [
          {
            field: 'promoDescription',
            direction: -1,
            type: 'custom',
            callback: (tempA, sort) => {
              if (this.isPromoMatch(tempA[sort.field])) {
                return 'AAA';
              } else {
                return 'ZZZ';
              }
            }
          },
          { field: 'name', direction: -1, type: 'string' }
        ],
        label: this._commonService.getPromoDescription(),
        sort_at: 'client'
      },
      aisles: {
        // dummy, needs to be here for now for backwards compatibility
        field: 'groupByTemplate',
        rule: [],
        label: 'Aisles',
        sort_at: 'client'
      },
      aisles_departmentName: {
        field: 'departmentName',
        rule: [
          { field: 'departmentName', direction: -1, type: 'string' },
          { field: 'name', direction: -1, type: 'string' }
        ],
        label: 'Aisles',
        sort_at: 'client'
      },
      aisles_aisleName: {
        field: 'aisleName',
        rule: [
          { field: 'aisleName', direction: -1, type: 'string' },
          { field: 'name', direction: -1, type: 'string' }
        ],
        label: 'Aisles',
        sort_at: 'client'
      },
      aisles_shelfName: {
        field: 'shelfName',
        rule: [
          { field: 'shelfName', direction: -1, type: 'string' },
          { field: 'name', direction: -1, type: 'string' }
        ],
        label: 'Aisles',
        sort_at: 'client'
      },
      'bloomreach-top-sellers': {
        field: 'salesRank+asc',
        rule: null,
        label: 'Top sellers',
        sort_at: 'server'
      },
      'bloomreach-price-low-high': {
        field: 'price+asc',
        rule: null,
        label: 'Price low to high',
        sort_at: 'server'
      },
      'bloomreach-best-match': {
        field: '',
        rule: null,
        label: 'Best Match',
        sort_at: 'server'
      },
      'bloomreach-club-card': {
        field: 'promoType+asc',
        rule: null,
        label: this._commonService.getPromoDescription(),
        sort_at: 'server'
      },
      aisles_coupons: {
        // dummy, needs to be here for now for backwards compatibility
        field: 'purchaseInd',
        rule: [{ field: 'purchaseInd', direction: -1, type: 'string' }],
        label: 'Type of Coupons',
        sort_at: 'client'
      },
      FREQUENCY: {
        field: 'FREQUENCY',
        rule: null,
        label: 'Frequently Purchased',
        sort_at: 'server'
      },
      PURCHASE_DATE: {
        field: 'PURCHASE_DATE',
        rule: null,
        label: 'Purchase Date',
        sort_at: 'server'
      },
      RECOMMENDED: {
        field: 'RECOMMENDED',
        rule: null,
        label: 'Recommended',
        sort_at: 'server'
      },
      RECENTLY_PURCHASED: {
        field: 'PURCHASE_DATE',
        rule: null,
        label: 'Recently Purchased',
        sort_at: 'server'
      }
    };

    return results;
  }

  private isPromoMatch(label: string): boolean {
    const promoRules = this._commonService.getPromorulesArray();


    if (!promoRules || promoRules.length === 0) {
      return false;
    }

    let found = false;
    promoRules.forEach(function (promoRule: { [x: string]: { [Symbol.match](string: string): RegExpMatchArray | null; }; }) {
      if (label && label.length > 0) {
        if (label.match(promoRule['rule'])) {
          found = true;
        }
      }
    });

    return found;
  }

  public constructor(public _commonService: AbsCommonService) {


    this.rules = this.initRules();
    this.available = (this.windowObj['AB'] && this.windowObj['AB']['availableSorts']) || [];

    if (this.hasSort()) {
      this.generate();
    }
  }

  public setAvailableSort(sort: string[]) {
    this.available = sort;
  }

  public getDefaultSort() {

    if (this.default) {
      return this.default;
    }

    if (this.available.filter(rule => rule === 'a-z').length > 0) {
      this.default = this.getSortByName('a-z');
    } else {
      this.default = this.available[0] ? this.getSortByName(this.available[0]) : this.getSortByName('a-z');
    }

    return this.default;
  }

  public getDefaultSortForConfigurableSort(defaultRule: string) {

    if (this.available.filter(rule => rule === defaultRule).length > 0) {
      this.default = this.getSortByName(defaultRule);
    } else {
      this.default = this.available[0] ? this.getSortByName(this.available[0]) : this.getSortByName(defaultRule);
    }

    return this.default;
  }

  public hasSort() {
    return !!this.available.length;
  }

  public getSortByName(name: string) {
    return this.rules[name];
  }

  /**
  * Given a comma-delimited string of sort names, return the collection of SortModels
  */
  public getSortOptions(sortValues: string) {
    let sortOptions: SortModel[] = [];

    if (sortValues) {
      // Break up the comma-delimited collection into an array
      let valueCollection = sortValues.split(',');

      // Iterate over each specified sort name, looking it up in the collection of rule and
      // if found, append it to the returned SortModel collection
      valueCollection.forEach((sortName: string, index: number) => {
        const sortRule = this.getSortByName(sortName.trim());
        if (sortRule)
          sortOptions.push(new SortModel(sortRule));
      });
    }

    return sortOptions;
  }

  public getSorts() {
    return this.sorts;
  }

  public sort(sort: SortModel, data: ProductModel[]): ProductModel[] {
    if (!sort || !sort.rule) {
      return data;
    }

    return data.sort((a: ProductModel, b: ProductModel) => {
      if(sort?.rule) {
        for (let rule of sort.rule) {
          let tempA = {...a};
          let tempB = {...b};

          if (rule.type === 'string') {
              if (tempA && tempA[rule.field]) {
                  tempA[rule.field] = tempA[rule.field].toString().toLowerCase();
              }
              if (tempB && tempB[rule.field]) {
                  tempB[rule.field] = tempB[rule.field].toString().toLowerCase();
              }
          }

          if (rule.type === 'number') {
              tempA[rule.field] = parseFloat(tempA[rule.field]);
              tempB[rule.field] = parseFloat(tempB[rule.field]);
          }

          if (rule.type === 'custom' && rule.callback) {
              const result = rule.callback.call(this, tempA, sort);
              if (typeof result === 'number') {
                return result;
              }
          }

          if (tempA[rule.field] < tempB[rule.field]) {
              return rule.direction === 1 ? -1 : 1;
          } else if (tempA[rule.field] > tempB[rule.field]) {
              return rule.direction === 1 ? 1 : -1;
          }
        }
      }
      return 0;
    });
  }

  public couponsSort(sort: SortModel, data: CouponModel[]): CouponModel[] {
    if (!sort || !sort.rule) {
        return data;
    }

    return data.sort((a: CouponModel, b: CouponModel) => {
      if (sort?.rule) {
        for (let rule of sort.rule) {
          let tempA = {...a};
          let tempB = {...b};

          if (rule.type === 'string') {
              if (tempA && tempA[rule.field]) {
                  tempA[rule.field] = tempA[rule.field].toString().toLowerCase();
              }
              if (tempB && tempB[rule.field]) {
                  tempB[rule.field] = tempB[rule.field].toString().toLowerCase();
              }
          }

          if (rule.type === 'number') {
              tempA[rule.field] = parseFloat(tempA[rule.field]);
              tempB[rule.field] = parseFloat(tempB[rule.field]);
          }

          if (rule.type === 'custom' && rule.callback) {
              const result = rule.callback.call(this, tempA, sort);
              if (typeof result === 'number') {
                  return result;
              }
          }

          if (tempA[rule.field] < tempB[rule.field]) {
              return rule.direction === 1 ? -1 : 1;
          } else if (tempA[rule.field] > tempB[rule.field]) {
              return rule.direction === 1 ? 1 : -1;
          }
        }
      }
      return 0;
    });
}


  public generate() {
    if (this.available.length === 0) {
      return;
    }

    this.sorts = [];

    this.available.forEach((type: string, index: number) => {
      const rule = this.rules[type];

      if (!rule) {
        return;
      }

      /* overwrite with custom group by rule based on headerType setting */
      if (rule.field === 'groupByTemplate') {
        const groupByRuleKey = 'aisles' + '_' + this.windowObj['AB']['headerType'];
        rule.rule = this.rules[groupByRuleKey] ? this.rules[groupByRuleKey].rule : '';
      }
      this.sorts.push(new SortModel(rule));

      if (this.default === undefined && type === this.windowObj['AB']['defaultSort']) {
        this.default = rule;
      }
    });
  }
}

export { CouponModel };
